/* eslint-disable consistent-return */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import { B2CDesc } from '@constants/b2c';
import { codeMap } from '@constants/code';
import {
  SelectType,
  ChartType,
  SurveyCategory,
  surveyObj,
  TAnswer,
  TParsedSurvey,
  insuranceSurveyObj,
} from '@constants/enum';
import _ from 'lodash';
import moment from 'moment';

export function getSurveyObj(key: string): TParsedSurvey {
  const depth = key.length; // ex) key = 'aaa' then depth = 3
  const targetSurveyObj = {
    ...surveyObj,
    ...insuranceSurveyObj,
  };
  const targetParentsSurvey = targetSurveyObj[key.slice(0, 1)]; // 해당 key가 포함된 최상위 설문
  const surveysByDepthArr = [targetParentsSurvey];

  // key가 length 2이상이어야 작동
  for (let i = 1; i < depth; i++) {
    surveysByDepthArr.unshift(surveysByDepthArr[0].children[key.slice(0, i + 1)]);
  }
  const [targetSurvey] = surveysByDepthArr;

  let { desc = ['예외상황 발생', key], label = `예외상황 발생 key: ${key}` } = targetSurvey;
  if (_.isEmpty(targetSurvey?.desc)) {
    if (targetSurvey?.category === SurveyCategory.Middle) {
      if (targetSurvey?.selectType === SelectType.Check) {
        desc = ['관련된 증상을 모두 선택하세요.'];
      } else {
        desc = ['관련된 증상을 하나 선택하세요.'];
      }
    }
  }

  if (targetSurvey?.category === SurveyCategory.End) {
    const parents = surveysByDepthArr[1];
    label = targetSurvey?.label ? targetSurvey?.label : `${parents?.label}`;
    desc = _.isEmpty(targetSurvey?.desc) ? [] : targetSurvey?.desc;
    if (targetSurvey?.selectType !== SelectType.Check) {
      const target = parents?.answers?.find((e) => e?.value === key || e?.next === key)?.label;
      const symptom = target ? `<${target}>` : ``;
      if (symptom.length) {
        desc = _.uniq([symptom, ...desc]);
      }
    }
  }

  return {
    formKey: key,
    label,
    desc,
    postfix: targetSurvey?.postfix,
    deprecated: targetSurvey.deprecated,
    defaultDate: targetSurvey.defaultDate,
    defaultValue: targetSurvey.defaultValue,
    category: targetSurvey.category,
    selectType: targetSurvey.selectType,
    chartType: targetSurvey.chartType,
    answers: targetSurvey.answers ?? [],
    childrenKeys: _.keys(targetSurvey?.children ?? {}),
  };
}

function parsingNestedSurvey(keyArr: string[]) {
  const result: any[] = [];
  if (keyArr?.length) {
    keyArr.forEach((k) => {
      const {
        label,
        desc,
        selectType,
        chartType,
        answers: rawAnswers = [],
        childrenKeys = [],
        postfix,
        deprecated,
        defaultDate,
        defaultValue,
      }: TParsedSurvey = getSurveyObj(k);
      const answers = rawAnswers;
      // const answers = rawAnswers.map((e) => _.omit(e, ['next']));
      let symptomCode;
      if (k.length > 1) {
        symptomCode = getSurveyObj(k.slice(0, -1))?.answers?.find(
          (a: TAnswer) => a?.next === k || a?.value === k,
        )?.symptomCode;
      }
      const v = {
        label,
        desc: desc?.map((s: string) => s.replace(/[<>]/g, '')),
        symptomCode,
        selectType: SelectType[selectType],
        chartType: chartType === undefined ? undefined : ChartType[chartType],
        answers,
        postfix,
        deprecated,
        defaultDate,
        defaultValue,
      };
      if (_.isEmpty(answers)) delete v.answers;
      if (symptomCode === undefined) delete v.symptomCode;
      result.push([k, v]);
      if (childrenKeys?.length) {
        result.push(...parsingNestedSurvey(childrenKeys));
      }
    });
  }
  return result;
}

export function parsingSurveyObjToCodeMapper() {
  const s = [..._.keys(surveyObj), ..._.keys(insuranceSurveyObj)];
  console.log(s);
  const arr = parsingNestedSurvey(s);
  // 화면상 필요없는 설문 키 제거
  // const exceptKeyArr = ['d', 'e', 'f', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  // const result = arr.filter((e) => !exceptKeyArr.includes(e[0]));

  // console.log(JSON.stringify(surveyObj, null, 2));
  const result = arr;
  console.log(result);
}

function getSCode(surveyCode: string) {
  const result: any = [];
  const data = getSurveyObj(surveyCode);
  if (!_.isEmpty(data.answers)) {
    _.forEach(data.answers, (answer: any) => {
      if (!_.isEmpty(answer?.symptomCode)) {
        _.forEach(answer?.symptomCode, (sCode: string) => {
          result.push({
            symptomCode: sCode,
            surveyCode: typeof answer.value === 'number' ? answer.next : answer.value,
            label: answer?.label,
          });
        });
      }
    });
  }
  if (!_.isEmpty(data.childrenKeys)) {
    _.forEach(data.childrenKeys, (child: string) => {
      result.push(...getSCode(child));
    });
  }
  return result;
}

export function sCodeMapper() {
  const result: any = {};
  const categorys = _.keys(surveyObj);

  _.forEach(categorys, (category: string) => {
    const res = getSCode(category);
    if (!_.isEmpty(res)) {
      _.forEach(res, (e) => {
        if (!_.isEmpty(result[e.symptomCode])) {
          result[e.symptomCode] = [
            ...result[e.symptomCode],
            {
              surveyCode: e.surveyCode,
              label: e.label,
            },
          ];
        } else {
          result[e.symptomCode] = [
            {
              surveyCode: e.surveyCode,
              label: e.label,
            },
          ];
        }
      });
    }
  });
  console.log(result);
  return result;
}

const selectSurvey = (rawSurvey: string) => {
  const codeArray = Array.from(codeMap, ([k]) => k);
  // console.log(rawSurvey);
  if (rawSurvey === 'none') {
    return [];
  }
  if (!rawSurvey) {
    return [];
  }
  const survey = JSON.parse(rawSurvey);
  const result = survey.reduce((a, res: any) => {
    const surveyData = codeMap.get(res.code);
    if (!surveyData) {
      return a;
    }
    if (res.desc) {
      // 주관식 답이 존재하면 이유 불문 보여줌
      return [...a, res];
    }
    if (surveyData.selectType === 'NumberInput') {
      // 숫자 입력 타입은 무조건 보여줌
      return [...a, res];
    }
    if (typeof res.value === 'number' && ![-1].includes(res.value)) {
      // 응답값이 숫자인 경우 설문 노출 여부 판단
      // @ts-ignore
      const targetAnswer = surveyData?.answers?.find((e) => e.value === res.value) ?? {};
      if (!_.isEmpty(targetAnswer?.symptomCode) || targetAnswer?.mustShowFlagInYejinSymptomTable) {
        return [...a, res];
      }
      return a;
    }
    if (_.isArray(res.value)) {
      // 응답 값이 숫자 배열인 경우 설문 노출 여부 판단
      const refinedValue = (res.value as Array<string | number>).filter(
        (e) => typeof e === 'number' && ![-1].includes(e),
      );
      let flag = false;
      refinedValue.forEach((r) => {
        // @ts-ignore
        const targetAnswer = surveyData?.answers?.find((e) => e.value === r);
        if (!_.isEmpty(targetAnswer?.symptomCode || targetAnswer?.mustShowFlagInYejinSymptomTable)) {
          flag = true;
          return false; // forEach 반복문 종료
        }
      });
      if (flag) {
        return [...a, res];
      }
      return a;
    }
    if (typeof res.value === 'string') {
      if (moment(res.value).isValid()) {
        // 응답 값이 날짜인 경우 설문 노출 여부 판단
        return [...a, res];
      }
      return a;
    }
    if (_.isObject(res.value)) {
      // 응답 포맷 상 object 형태의 응답은 scale, onset, onset&scale case만 존재
      return [...a, res];
    }
    return a;
  }, []);

  // console.log(codeArray);
  result.sort(
    (a, b) =>
      codeArray.findIndex((e: string) => e === a.code!) - codeArray.findIndex((e: string) => e === b.code!),
  );
  return result;
};

export const extractScodes = (surveyResponse: any) => {
  const surveys = selectSurvey(surveyResponse);
  // console.log('surveys', surveys);
  const sCodeInput: any[] = [];
  // 설문 데이터로 부터 증상코드 수집
  _.forEach(surveys ?? [], (e) => {
    const targetSurvey: any = codeMap.get(e.code);
    if (['Check', 'Radio'].includes(targetSurvey.selectType)) {
      const sCodes = (targetSurvey?.answers ?? []).reduce((a, c: any) => {
        const answerFlag = _.isArray(e.value) ? e.value.includes(c.value) : e.value === c.value;
        return [...a, ...(answerFlag ? c.symptomCode ?? [] : [])];
      }, []);
      _.forEach(sCodes, (code) => {
        sCodeInput.push({ code, check: false });
      });
    } else if (!_.isEmpty(targetSurvey.symptomCode)) {
      _.forEach(targetSurvey.symptomCode, (code) => {
        sCodeInput.push({ code, check: false });
      });
    }
  });
  return sCodeInput.filter((e) => e.code !== 'S000');
};

export const calculatePalgangResult = (팔강점수: {
  표: number;
  리: number;
  실: number;
  허: number;
  한: number;
  열: number;
  추가응답: {
    표: number;
    리: number;
    실: number;
    허: number;
    한: number;
    열: number;
  };
}) => {
  console.log(팔강점수);
  if (!팔강점수) return;
  let { 표, 리, 실, 허, 한, 열 } = 팔강점수;
  const { 표: 추가표, 리: 추가리, 실: 추가실, 허: 추가허, 한: 추가한, 열: 추가열 } = 팔강점수.추가응답;
  //
  if (!표 || !리 || 표 === 리) {
    if (!표) 표 = 0;
    if (!리) 리 = 0;
    표 += 추가표;
    리 += 추가리;
  }
  if (!실 || !허 || 실 === 허) {
    if (!실) 실 = 0;
    if (!허) 허 = 0;
    실 += 추가실;
    허 += 추가허;
  }
  if (!한 || !열 || 한 === 열) {
    if (!한) 한 = 0;
    if (!열) 열 = 0;
    한 += 추가한;
    열 += 추가열;
  }
  const 표리합 = 표 + 리;
  const 실허합 = 실 + 허;
  const 한열합 = 한 + 열;
  const 표백분율 = _.round((표 / (표리합 || 100)) * 100);
  const 리백분율 = 100 - 표백분율;
  const 실백분율 = _.round((실 / (실허합 || 100)) * 100);
  const 허백분율 = 100 - 실백분율;
  const 한백분율 = _.round((한 / (한열합 || 100)) * 100);
  const 열백분율 = 100 - 한백분율;

  const 양 = 표 * 0.1 + 열 * 0.65 + 실 * 0.25;
  const 음 = 리 * 0.1 + 한 * 0.65 + 허 * 0.25;
  const 양음합 = 양 + 음;
  const 양백분율 = _.round((양 / (양음합 || 100)) * 100);
  const 음백분율 = 100 - 양백분율;

  const 판정결과 = `${표 > 리 ? '표' : '리'}${한 > 열 ? '한' : '열'}${실 > 허 ? '실' : '허'}${양 > 음 ? '양' : '음'}`;
  return {
    판정결과,
    표백분율,
    리백분율,
    실백분율,
    허백분율,
    한백분율,
    열백분율,
    양백분율,
    음백분율,
  };
};

const byeonjeungMap = new Map([
  ['B004', { 허실: 1, 노폐물: -3, 급성만성: 0, 한열: 2 }], // 습열
  ['B009', { 허실: 2, 노폐물: -2, 급성만성: 0, 한열: 0 }], // 풍습
  ['B013', { 허실: 1, 노폐물: -2, 급성만성: -2, 한열: -3 }], // 리한
  ['B014', { 허실: 0, 노폐물: 0, 급성만성: 0, 한열: 1 }], // 기체
  ['B015', { 허실: 1, 노폐물: -3, 급성만성: 1, 한열: 1 }], // 식적
  ['B017', { 허실: 1, 노폐물: -3, 급성만성: -3, 한열: 0 }], // 혈어
  ['B025', { 허실: -3, 노폐물: 2, 급성만성: -1, 한열: -1 }], // 기허
  ['B026', { 허실: -3, 노폐물: -1, 급성만성: -3, 한열: -2 }], // 양허
  ['B027', { 허실: -3, 노폐물: 2, 급성만성: -2, 한열: -1 }], // 혈허
  ['B028', { 허실: -3, 노폐물: 2, 급성만성: -3, 한열: 1 }], // 음허
  ['B031', { 허실: 2, 노폐물: -1, 급성만성: 2, 한열: 1 }], // 풍한
  ['B032', { 허실: 3, 노폐물: -2, 급성만성: 3, 한열: 3 }], // 풍열
  ['B033', { 허실: -1, 노폐물: 2, 급성만성: 0, 한열: 1 }], // 기역
  ['B034', { 허실: 1, 노폐물: -2, 급성만성: 0, 한열: 0 }], // 수습
  ['B035', { 허실: 1, 노폐물: -3, 급성만성: 0, 한열: 0 }], // 담음
  ['B036', { 허실: 2, 노폐물: -1, 급성만성: -2, 한열: 3 }], // 리열
]);

export const caculateByeonjeungResult = (b: any = []) => {
  const limit = 5;
  const sortedB = _.sortBy(b, 'weight').reverse().slice(0, limit);
  const sortedBResult = sortedB.reduce(
    (a, c) => {
      const target = byeonjeungMap.get(c.code);
      const { weight } = c;
      ['허실', '노폐물', '급성만성', '한열'].forEach((key) => {
        if (target[key] !== 0) {
          a[key] += (target[key] ?? 0) * weight;
          a[`${key}totalWeight`] += weight;
        }
      });
      return a;
    },
    {
      허실: 0,
      노폐물: 0,
      급성만성: 0,
      한열: 0,
      허실totalWeight: 0,
      노폐물totalWeight: 0,
      급성만성totalWeight: 0,
      한열totalWeight: 0,
    },
  );
  return {
    허실: _.round(sortedBResult.허실 / sortedBResult.허실totalWeight, 2),
    노폐물: _.round(sortedBResult.노폐물 / sortedBResult.노폐물totalWeight, 2),
    급성만성: _.round(sortedBResult.급성만성 / sortedBResult.급성만성totalWeight, 2),
    한열: _.round(sortedBResult.한열 / sortedBResult.한열totalWeight, 2),
  };
};

export const byeonjeungWeight = new Map([
  ['B004', 1.1], // 습열
  ['B009', 0.8], // 풍습
  ['B013', 0.85], // 리한
  ['B014', 0.85], // 기체
  ['B015', 0.7], // 식적
  ['B017', 0.85], // 혈어
  ['B025', 1.25], // 기허
  ['B026', 1.5], // 양허
  ['B027', 1.2], // 혈허
  ['B028', 1.4], // 음허
  ['B031', 0.7], // 풍한
  ['B032', 0.7], // 풍열
  ['B033', 0.85], // 기역
  ['B034', 1.1], // 수습
  ['B035', 0.8], // 담음
  ['B036', 0.85], // 리열
]);

export const convertB2CResult = (bResult: { 허실: number; 노폐물: number; 한열: number }) => {
  const { 허실, 노폐물, 한열 } = bResult;
  const 허실기준 = 0;
  const 한열기준 = 0;
  const 노폐물기준 = 0;

  if (_.isNaN(허실) || _.isNaN(노폐물) || _.isNaN(한열)) {
    return {
      code: 'nnn',
      desc: B2CDesc.nnn,
    };
  }

  const b2cResult = `${허실 > 허실기준 ? 'a' : 'b'}${노폐물 > 노폐물기준 ? 'a' : 'b'}${한열 > 한열기준 ? 'a' : 'b'}`;
  return {
    code: b2cResult,
    desc: B2CDesc[b2cResult],
  };
};
